/**
 * Clerk Configuration
 * 
 * Centralized configuration for Clerk authentication
 */

export const clerkConfig = {
  // Get publishable key from environment
  publishableKey: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY || "",
  
  // Get secret key from environment (server-side only)
  secretKey: process.env.CLERK_SECRET_KEY || "",
  
  // Sign-in/Sign-up page URLs (where users go to authenticate)
  signInUrl: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL || "/sign-in",
  signUpUrl: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL || "/sign-up",
  
  // Redirect URLs after authentication (new props - replaces deprecated afterSignInUrl/afterSignUpUrl)
  // Use signInFallbackRedirectUrl/signUpFallbackRedirectUrl for optional redirects
  // Use signInForceRedirectUrl/signUpForceRedirectUrl for mandatory redirects
  signInFallbackRedirectUrl: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_FALLBACK_REDIRECT_URL || "/",
  signUpFallbackRedirectUrl: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL || "/",
  signInForceRedirectUrl: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_FORCE_REDIRECT_URL,
  signUpForceRedirectUrl: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL,
  
  // After sign out URL
  afterSignOutUrl: process.env.NEXT_PUBLIC_CLERK_AFTER_SIGN_OUT_URL || "/sign-in",
  
  // Clerk domain (optional, for custom domains)
  domain: process.env.CLERK_DOMAIN,
};

/**
 * Validate Clerk configuration
 * Throws an error if required environment variables are missing
 */
export function validateClerkConfig(): void {
  if (!clerkConfig.publishableKey) {
    throw new Error(
      "NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY is required. Please add it to your .env.local file."
    );
  }

  if (typeof window === "undefined" && !clerkConfig.secretKey) {
    // Only check secret key on server-side
    console.warn(
      "CLERK_SECRET_KEY is not set. This is required for server-side operations."
    );
  }
}

/**
 * Check if Clerk is properly configured
 */
export function isClerkConfigured(): boolean {
  return !!clerkConfig.publishableKey;
}

